// GENERATED FILE - DO NOT MODIFY

export enum UserExternalIdentityIssuerDto {
    Google = "Google",
    OktaAppcom = "OktaAppcom",
}